import React, { useRef, useContext, useState, useEffect, useCallback } from "react";
import pencil from "../../assets/pencil.png";
import trash from "../../assets/trash.png";
import printer from "../../assets/Printer.png";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { useReactToPrint } from "react-to-print";
import GeneralModal from "../../helpers/GeneralModal";
import { createModal } from "react-modal-promise";
import LogicContext from "../../Context/LogicContext";
import { SetStockTransferEdit } from "../../store/stockTransferAtom";
import { Dropdown } from 'react-bootstrap';
import { stockTransferService } from "../../services/stockTransferService";
import StockTransferScroll from "./StockTransferScroll";
import { formatCustomDate } from "../../helpers/formatCustomDate";

const StockTransferDetailsPage = () => {
  const [selectedList, setSelectedList] = useState([]);
  const myPromiseModal = createModal(GeneralModal);
  const setStockTransferEdit = SetStockTransferEdit();

  const { id } = useParams();
  const navigate = useNavigate();
  const logicContext = useContext(LogicContext);
  const [stockTransferDetails, setStockDetails] = useState({
    transfer_main: [],
    transfer_details: [],
    action_status: [],
  });

  const { pathname } = useLocation();
  const printRef = useRef(null);

  const url = pathname.split("/");
  const currModuleId = url[1];
  const currModuleName = url[2];
  const currUserMenu = url[3];

  useEffect(() => {
    document.title = "Stock Transfer Details";
    let isMounted = true;

    if (isMounted) {
      loadDetailsData();
    }

    return () => {
      isMounted = false;
    };
  }, [id]);

  const loadDetailsData = () => {
    stockTransferService.stockTransferDetails(id).then((response) => {
      if (response.data) {
        setStockDetails(response.data);
      }
    });
  }

  const editCurrentData = async () => {
    const response = await myPromiseModal({
      title: "Modify Transfer",
      body: "Do you want to modify this record?",
      showInput: false,
    });

    if (response.decision === true) {
      setStockTransferEdit(stockTransferDetails);
      navigate(`/${currModuleId}/${currModuleName}/${currUserMenu}/add-new`);
    }
  };

  async function bulkActionsSingle(action) {
    const option = action.action_option;
    const result = await myPromiseModal({
      title: 'confirm your action!',
      body: `Do you want to ${action.status_name} ?`,
      showInput: false,
      placeHolder: '',
    });
    if (result.decision === false) {
      return;
    }

    try {
      const payload = { option: option, ref_no: id }
      const res = await stockTransferService.stockTransferAction(payload);
      const response = logicContext.httpResponseManager(res.data?.[0] || res.data?.result_status?.[0]);

      if (response.message_id === 1) {
        logicContext.showToast(response.message_text || ' successfully!', 'success');
        loadDetailsData();
      } else {
        logicContext.showToast(response.message_text || 'Failed to save', 'error');
      }
    } catch (error) {
      console.log("error", error);
    }
  }

  const handlePrint = useReactToPrint({
    content: () => printRef.current,
    documentTitle: `Stock_Opening_${stockTransferDetails?.transfer_main?.[0]?.ref_no}`,
    onAfterPrint: () => console.log("Printed successfully"),
  });

  const onSelection = (list) => {
    const tempList = list?.filter((item) => item.checked === true);
    setSelectedList(tempList);
  };

  const getStatusColor = (statusName, statusId) => {
    switch (statusId) {
      case 4:
        return "bg-green-100 text-green-700";
      case 3:
        return "bg-yellow-100 text-yellow-700";
      case 2:
        return "bg-blue-100 text-blue-700";
      case 1:
        return "bg-red-100 text-red-700";
      default:
        return "bg-gray-100 text-gray-700";
    }
  };

  const viewItemDetails = useCallback(
    adId => {
      navigate(`/${currModuleId}/${currModuleName}/${currUserMenu}/details/${adId}`);
    },
    [currModuleId, currModuleName, navigate]
  );

  return (
    <section className="mt-4  w-full mx-auto px-4 sm:px-6 lg:px-8">
      <div className="flex justify-end gap-3 mb-6">
        {stockTransferDetails?.action_status?.length > 0 && 
          <Dropdown>
            <Dropdown.Toggle
              className="text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 px-4 py-2 rounded-lg transition duration-200 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
              id="dropdown-basic"
            >
              ACTION
            </Dropdown.Toggle>
            <Dropdown.Menu className="mt-2 shadow-lg border border-gray-200 rounded-md bg-white divide-y divide-gray-100">
              {stockTransferDetails?.action_status?.map((option, i) => (
                <Dropdown.Item 
                  key={i} 
                  onClick={() => bulkActionsSingle(option)} 
                  className="hover:bg-gray-100 py-2 px-4 text-sm text-gray-700 cursor-pointer"
                >
                  {option?.status_name}
                </Dropdown.Item>
              ))}
            </Dropdown.Menu>
          </Dropdown>
        }

        <button
          onClick={handlePrint}
          className="flex items-center gap-2 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition duration-200 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
        >
          <img src={printer} alt="Print" className="w-5 h-5" />
          <span className="hidden sm:inline text-sm font-medium">Print</span>
        </button>

        <button
          onClick={editCurrentData}
          className="p-2 bg-amber-500 text-white rounded-lg hover:bg-amber-600 transition duration-200 focus:outline-none focus:ring-2 focus:ring-amber-500 focus:ring-offset-2"
          title="Edit"
        >
          <img src={pencil} alt="Edit" className="w-6 h-6" />
        </button>

        <button
          // onClick={deleteCurrentData}  ← uncomment when delete logic is ready
          className="p-2 bg-red-500 text-white rounded-lg hover:bg-red-600 transition duration-200 opacity-50 cursor-not-allowed"
          title="Delete (not implemented)"
        >
          <img src={trash} alt="Delete" className="w-6 h-6" />
        </button>
      </div>

      <div className="flex flex-col lg:flex-row gap-6 lg:gap-8">
        {/* Left Sidebar - Scroll List */}
        <div className="w-full lg:w-1/4 bg-white shadow-md rounded-xl overflow-hidden">
          <StockTransferScroll onSelection={onSelection} viewItemDetails={viewItemDetails} />
        </div>

        {/* Main Details Card - PRINTABLE AREA */}
        <div ref={printRef} className="flex-1 bg-white shadow-xl rounded-xl overflow-hidden ring-1 ring-gray-200">
          <div className="p-6 lg:p-8">
            {/* Header */}
            <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center border-b border-gray-200 pb-4 mb-6">
              <div>
                <h1 className="text-2xl font-bold text-gray-900">Stock Transfer Details</h1>
                <p className="text-sm text-gray-500 mt-1">
                  Ref No: {stockTransferDetails?.transfer_main?.[0]?.ref_no || "—"}
                </p>
              </div>
              <span
                className={`mt-3 sm:mt-0 px-4 py-1.5 rounded-full text-sm font-medium ${getStatusColor(
                  stockTransferDetails?.transfer_main?.[0]?.status_name, 
                  stockTransferDetails?.transfer_main?.[0]?.status_id
                )}`}
              >
                {stockTransferDetails?.transfer_main?.[0]?.status_name || "—"}
              </span>
            </div>

            {/* Info Grid */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-8 gap-y-4 mb-8">
              <div>
                <p className="text-sm font-medium text-gray-500">Transfer No.</p>
                <p className="mt-1 text-base font-semibold text-gray-900">{stockTransferDetails?.transfer_main?.[0]?.transfer_number || "—"}</p>
              </div>
              <div>
                <p className="text-sm font-medium text-gray-500">Transfer Date</p>
                <p className="mt-1 text-base font-semibold text-gray-900">{formatCustomDate(stockTransferDetails?.transfer_main?.[0]?.transfer_date) || "—"}</p>
              </div>
              <div>
                <p className="text-sm font-medium text-gray-500">Transfer From</p>
                <p className="mt-1 text-base font-semibold text-gray-900">{stockTransferDetails?.transfer_main?.[0]?.warehouse_from_name || "—"}</p>
              </div>

              <div>
                <p className="text-sm font-medium text-gray-500">Transfer To</p>
                <p className="mt-1 text-base font-semibold text-gray-900">{stockTransferDetails?.transfer_main?.[0]?.warehouse_to_name || "—"}</p>
              </div>

              <div className="sm:col-span-2">
                <p className="text-sm font-medium text-gray-500">Encoded By</p>
                <p className="mt-1 text-base font-semibold text-gray-900">{stockTransferDetails?.transfer_main?.[0]?.encoded_by_name || "—"}</p>
              </div>
              
              <div className="sm:col-span-2">
                <p className="text-sm font-medium text-gray-500">Encoded Date</p>
                <p className="mt-1 text-base font-semibold text-gray-900">{formatCustomDate(stockTransferDetails?.transfer_main?.[0]?.encoded_date) || "—"}</p>
              </div>
              <div className="sm:col-span-2">
                <p className="text-sm font-medium text-gray-500">Received By</p>
                <p className="mt-1 text-base font-semibold text-gray-900">{stockTransferDetails?.transfer_main?.[0]?.received_by_name || "—"}</p>
              </div>
              <div className="sm:col-span-2">
                <p className="text-sm font-medium text-gray-500">Approved By</p>
                <p className="mt-1 text-base font-semibold text-gray-900">{stockTransferDetails?.transfer_main?.[0]?.approved_by_name || "—"}</p>
              </div>
              <div className="sm:col-span-2">
                <p className="text-sm font-medium text-gray-500">Approved Date</p>
                <p className="mt-1 text-base font-semibold text-gray-900">{stockTransferDetails?.transfer_main?.[0]?.approved_date ? formatCustomDate(stockTransferDetails?.transfer_main?.[0]?.approved_date) : "—"}</p>
              </div>
              <div className="sm:col-span-2">
                <p className="text-sm font-medium text-gray-500">Received Date</p>
                <p className="mt-1 text-base font-semibold text-gray-900">{stockTransferDetails?.transfer_main?.[0]?.received_date ? formatCustomDate(stockTransferDetails?.transfer_main?.[0]?.received_date) : "—"}</p>
              </div>
              <div className="sm:col-span-2">
                <p className="text-sm font-medium text-gray-500">Remarks</p>
                <p className="mt-1 text-base text-gray-900">{stockTransferDetails?.transfer_main?.[0]?.remark || "—"}</p>
              </div>
            </div>

            {/* Line Items Table */}
            <div>
              <h2 className="text-lg font-semibold text-gray-900 mb-4">Line Items</h2>
              <div className="overflow-x-auto border border-gray-200 rounded-lg shadow-sm">
                <table className="min-w-full divide-y divide-gray-200 text-sm">
                  <thead className="bg-gray-50 text-gray-700 uppercase text-xs font-semibold">
                    <tr>
                      <th scope="col" className="px-6 py-3 text-left">Item</th>
                      <th scope="col" className="px-6 py-3 text-left">SKU</th>
                      <th scope="col" className="px-6 py-3 text-left">Type</th>
                      <th scope="col" className="px-6 py-3 text-left">Category</th>
                      <th scope="col" className="px-6 py-3 text-center">Unit</th>
                      <th scope="col" className="px-6 py-3 text-center">Qty</th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-gray-200 bg-white">
                    {stockTransferDetails?.transfer_details?.length > 0 ? (
                      stockTransferDetails.transfer_details.map((item, index) => (
                        <tr 
                          key={item.item_id} 
                          className={`${index % 2 === 0 ? 'bg-gray-50' : 'bg-white'} hover:bg-gray-100 transition-colors`}
                        >
                          <td className="px-6 py-4 text-gray-900">{item.item_name}</td>
                          <td className="px-6 py-4 text-gray-600">{item.item_sku}</td>
                          <td className="px-6 py-4 text-gray-900">{item.item_type_name}</td>
                          <td className="px-6 py-4 text-gray-900">{item.item_category_name}</td>
                          <td className="px-6 py-4 text-center text-gray-900">{item.item_unit_name}</td>
                          <td className="px-6 py-4 text-center font-semibold text-gray-900">
                            {item.item_quantity}
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan={6} className="px-6 py-8 text-center text-gray-500">
                          No line items found.
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default StockTransferDetailsPage;